<div
  class="ddc-read-word-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- Header with word title and privacy -->
  <div class="sheet-header">
    <div class="header-left">
      <ddc-text-gradient
        class="text-xl"
        [_icon]="'fiber_manual_record'"
        [_text]="'Word'"
        [_type]="'1'"
      ></ddc-text-gradient>

      <div class="content-row dictionaries" *ngIf="word()?.dictionaries?.length">
        <ddc-dic-s
          class="dictionary-item"
          *ngFor="let dic of word()?.dictionaries | slice: 0 : 3"
          [label]="dic.title"
        ></ddc-dic-s>
      </div>
      @if (word().category !== undefined && word().category?.label.length > 0) {
        <ddc-card-category [category]="word().category.label"></ddc-card-category>
      }
      <ddc-privacy [code]="word()?.privacy" [withText]="false"></ddc-privacy>
      <!-- Dictionaries row -->
    </div>
    <div class="header-right" *ngIf="word()?.privacy">
      <ddc-country-flag [ddc_lng]="word().language" [has_label]="false"></ddc-country-flag>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Content section -->
  <div class="sheet-content">
    <!-- Word details row -->
    <ddc-profile-pic
      [dynamicRoute]="'/users/' + word()?.owner?.username"
      [followerCount]="word()?.owner?.followers_count"
      [minimal]="true"
      [subscription]="word()?.owner?.subscription"
      [username]="word()?.owner?.username"
      [userProfilePic]="word()?.owner?.profile_pic"
      (click)="onProfilePicClick()"
    ></ddc-profile-pic>

    <div class="content-row word-details">
      <span class="word-article" *ngIf="word()?.article">{{ word()?.article }}</span>
      <span class="word-text">{{ word()?.word }}</span>
      <span class="word-pos" *ngIf="word()?.pos">[{{ word()?.pos }}]</span>
    </div>

    <!-- Definition section -->
    <div class="content-row" *ngIf="word()?.definition">
      <div class="section-header">
        <mat-icon>description</mat-icon>
        <span>Definition</span>
      </div>
      <div class="section-content">{{ word()?.definition }}</div>
    </div>

    <!-- Example section -->
    <div class="content-row" *ngIf="word()?.example">
      <div class="section-header">
        <mat-icon>format_quote</mat-icon>
        <span>Example</span>
      </div>
      <div class="section-content">{{ word()?.example }}</div>
    </div>

    <!-- Tags section -->
    <div class="content-row tags" *ngIf="word()?.tags?.length">
      <div class="section-header">
        <mat-icon>local_offer</mat-icon>
        <span>Tags</span>
      </div>
      <div class="tags-container">
        <span class="tag-item" *ngFor="let tag of word()?.tags">{{ tag.label }}</span>
      </div>
    </div>
  </div>
</div>
